import { CustomCornerEditorDockingPanelContent } from "./content/customCornerEditorDockingPanelContent";
import { DockingPanel, IDockingPanelOptions } from "./dockingPanel";

export class CustomCornerDockingPanel {
    private readonly panel: DockingPanel;
    private visible: boolean;

    constructor(container: HTMLElement) {
        this.visible = false;

        const component = (<CustomCornerEditorDockingPanelContent />);

        const options: IDockingPanelOptions = {
            style: {
                width: "360px",
                height: "460px",
                minWidth: "360px",
                minHeight: "460px",
                resize: "both",
                left: "2px",
                top: "2px",
            },
        };

        this.panel = new DockingPanel(
            container,
            "dextall-studio-wall-custom-corner-editor",
            "Corner properties",
            component,
            options,
        );

        this.panel.addVisibilityListener((x: boolean) => this.visible = x);
    }

    setVisible(visibility: boolean) {
        if (this.visible === visibility) {
            return;
        }

        this.visible = visibility;
        this.panel.setVisible(visibility);
    }

    shutdown() {
        this.panel.shutdown();
    }
}
